var ValueJS = ValueJS || {};

ValueJS.ShopifyCart = function() {

    var _buttonClass = '.cart-item__quantity-btn';
    var _inputClass = '.cart-item__quantity-input';
    var _submitBtn = '.cart-submit-btn';
    var _ui = $(_buttonClass + ', ' + _inputClass + ', ' + _submitBtn);
    var _cartRowClass = '.cart-item';
    var _deleteCartRowBtn = 'a.cart-item__remove-btn';
    var _cartAlert = $('.cart__alert');

    var _init = function() {
        if ($('body').hasClass('template--cart')) {
            $(_buttonClass).on('click', _btnClickHandler);
            $(_inputClass)
                .on('focus', _inputFocusHandler)
                .on('change', _inputChangeHandler);
        }
    }

    var _btnClickHandler = function(e) {
        _disableUI();
        var btn = $(this);
        var input = btn.siblings(_inputClass);
        var variant = input.parents(_cartRowClass).data('variant');
        var quantity = btn.val() === '+' ? parseInt(input.val()) + 1 : parseInt(input.val()) - 1;
        _updateCart(variant, quantity, input, 'button');
    }

    var _inputFocusHandler = function(e) {
        var input = $(this);
        input.data('prev-value', input.val());
    }

    var _inputChangeHandler = function(e) {
        _disableUI();
        var input = $(this);
        var quantity = parseInt(input.val());
        var variant = input.parents(_cartRowClass).data('variant');
        _updateCart(variant, quantity, input, 'input');
    }

    var _updateCart = function(variant, quantity, input, trigger) {
        if (quantity === 0) {
            window.location.replace(input.parents(_cartRowClass).find(_deleteCartRowBtn).prop('href'));
        } else {
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                dataType: 'json',
                data: {
                    "id": variant,
                    "quantity": quantity
                }
            })
            // .done(function(data){
            //     var size = data.items.length;
            //     for (var i = 0; i < size; i++) {
            //         if (data.items[i].variant_id == variant) {
            //             var cartItemData = data.items[i];
            //             break;
            //         }
            //     }
            //     _updateCartUI(input, trigger, data, cartItemData);
            // })
            .done(function(data, status, request){
                var size = data.items.length;
                for (var i = 0; i < size; i++) {
                    if (data.items[i].variant_id == variant) {
                        var cartItemData = data.items[i];
                        break;
                    }
                }
                _updateCartUI(input, trigger, data, cartItemData);
                _alert('success', 'Cart updated successfully!')
            })
            .fail(function(request, status, error){
                // ValueJS.Bootstrap.Toast.show('error', request.responseJSON.description);
                _enableUI();
                _alert('danger', request.responseJSON.description)
            });
        }
    }

    var _alert = function(type, msg) {
        let output = '';

        output += '<div class="alert alert-' + type + ' alert-dismissible fade show mb-4" role="alert">';
            output += msg;
            output += '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>';
        output += '</div>';

        _cartAlert.html(output);
    }

    var _updateCartUI = function(input, trigger, cartData, cartItemData) {
        // update quantity
        var oldQuantity = parseInt(trigger === 'button' ? input.val() : input.data('prev-value'));
        if (oldQuantity === cartItemData.quantity) {
            if (trigger === 'input') {
                input.val(oldQuantity);
            }
            // ValueJS.BootstrapToast.create('You have added the maximum to your cart.')
        } else {
            if (cartItemData) {
                if (trigger === 'button') {
                    input.val(cartItemData.quantity);
                }
            }
            // ValueJS.BootstrapToast.create('Cart updated successfully.')
            ValueJS.MiniCart.update();
        }
        // update row totals
        let cartItem = $(_cartRowClass + '[data-variant="'+ cartItemData.variant_id +'"]');
        cartItem.find('.cart-item__original-line-price').text('€' + Shopify.formatMoney(cartItemData.original_line_price, '{{amount}}'));
        cartItem.find('.cart-item__line-price').text('€' + Shopify.formatMoney(cartItemData.line_price, '{{amount}}'));
        // update cart totals
        if (cartData) {
            $('.cart__original-total-price').text('€' + Shopify.formatMoney(cartData.original_total_price, '{{amount}}'));
            $('.cart__total-discount').text('€' + Shopify.formatMoney(cartData.total_discount, '{{amount}}'));
            if (cartData.total_discount === 0) {
                $('.cart__total-discount').parents('.cart__discount-row').addClass('d-none');
            } else {
                $('.cart__total-discount').parents('.cart__discount-row').removeClass('d-none');
            }
            $('.cart__total-price').text('€' + Shopify.formatMoney(cartData.total_price, '{{amount}}'));
        }
        _enableUI();
    }

    var _disableUI = function() {
        _ui.prop('disabled', true);
    }

    var _enableUI = function() {
        _ui.prop('disabled', false);
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();}
    };

}();

$(function() {
    ValueJS.ShopifyCart.init();
});
